import { MultiFieldSet } from "../../../../../../components/utils/useFieldSet";
import { JobAppQuestionAnswerRequest } from "../../../../../api-docs";
import { PublicJobSectionGraph } from "../../../../../graphql.types";
import { AppQuestionFragment } from "../../../../components/self-apply-application-form-fragments/app-questions/app-questions";
import { SelfApplySectionContainer } from "../../../../components/self-apply-section-container";

export const SelfApplyCustomQuestionsAppSection = (props: {
  fieldSet: MultiFieldSet<JobAppQuestionAnswerRequest>;
  section: PublicJobSectionGraph;
}) => {
  const { section, fieldSet } = props;
  const isRequired = (section?.jobQuestions ?? []).some((q) => {
    return q?.isRequired || false;
  });

  return (
    <SelfApplySectionContainer.Container
      key={section.id}
      description={section.description}
      title={section.name}
      isRequired={isRequired}
    >
      <SelfApplySectionContainer.Content>
        <div className="pt-8">
          <AppQuestionFragment {...fieldSet} questions={section.jobQuestions} />
        </div>
      </SelfApplySectionContainer.Content>
    </SelfApplySectionContainer.Container>
  );
};
